import axios from 'axios';
import API from '../config/api.config';
import { Socket } from '../services/phoenix';
import Debugger from '../services/debugger';

export default class ParkingLots {
  constructor() {
    this.API = API;
  }

  apiEndpoint() {
    return this.API.URL('parking_lots');
  }

  getParkingLots() {
    return axios.get(this.apiEndpoint());
  }

  getParkingLotById(id) {
    return axios.get(`${this.apiEndpoint()}/${id}`);
  }

  postParkingLot(payload) {
    return axios.post(this.apiEndpoint(), payload);
  }

  patchParkingLot(id, payload) {
    return axios.patch(`${this.apiEndpoint()}/${id}`, payload);
  }

  deleteParkingLot(id) {
    return axios.delete(`${this.apiEndpoint()}/${id}`);
  }

  getParkingSpaceByParkingLotId(id) {
    return axios.get(`${this.apiEndpoint()}/${id}/parking_spaces`);
  }

  getMissingDevicesByParkingLotId(id) {
    return axios.get(`${this.apiEndpoint()}/${id}/missing_devices`);
  }

  postParkingSpace(id, payload) {
    return axios.post(`${this.apiEndpoint()}/${id}/parking_spaces`, payload);
  }

  patchParkingSpace(parkingLotId, parkingSpaceId, payload) {
    return axios.patch(`${this.apiEndpoint()}/${parkingLotId}/parking_spaces/${parkingSpaceId}`, payload);
  }

  deleteParkingSpace(parkingLotId, parkingSpaceId) {
    return axios.delete(`${this.apiEndpoint()}/${parkingLotId}/parking_spaces/${parkingSpaceId}`);
  }


  /*
  *
  *
  * Parking Lot Lobby Websocket
  */
  // eslint-disable-next-line
  parkingLotSocket(parkingLotId) {
    const url = process.env.NODE_ENV === 'production' ? '/socket' : 'ws://localhost:4002/socket';
    const socket = new Socket(url);
    socket.connect();

    const channel = parkingLotId ? `parking_lot:${parkingLotId}` : `parking_lot_all:${this.API.mandate()}`;
    const events = socket.channel(channel);
    events.on('parking_state', (msg) => {
      Debugger.log('Got events message', msg);
    });

    events.join().receive('ok', ({ messages }) => Debugger.log('catching up', messages))
      .receive('error', ({ reason }) => Debugger.log('failed join', reason))
      .receive('timeout', () => Debugger.log('Networking issue. Still waiting...'));

    socket.onError(() => Debugger.log('there was an error with the connection!'));
    socket.onClose(() => Debugger.log('the connection dropped'));

    events.onError(() => Debugger.log('there was an error!'));
    events.onClose(() => Debugger.log('the channel has gone away gracefully'));

    return { events, socket };
  }

  /*
  *
  *
  * Stats
  */
  getCurrentUsage(params) {
    return axios.get(this.API.URL('current_usage'), {params: params});
  }

  getDailyStats(params) {
    return axios.get(this.API.URL('stats/daily'), {params: params});
  }

  getWorkload(params) {
    return axios.get(this.API.URL('workload'), {params: params});
  }
}
